import React from 'react'

/**
 * Empty state component shown when a channel has no messages
 * Returns null to show nothing - the LoadingIndicator handles the loading state
 */
export const ChannelEmptyState: React.FC = () => null
